
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index6eZCehJ1ZKMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/[[Error]]/index.vue?macro=true";
import { default as _91slug_93eF5L8fYqXdMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/[slug].vue?macro=true";
import { default as aboutgBeiGoynCbMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/about.vue?macro=true";
import { default as accountOrder2ODTNryqYaMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/accountOrder.vue?macro=true";
import { default as accountProductt5SzNbpF48Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/accountProduct.vue?macro=true";
import { default as addressPk6C16B7NaMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/address.vue?macro=true";
import { default as apparel_45hatIvbu1eMqnmMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/apparel-hat.vue?macro=true";
import { default as collect6Jhl8yOHQSMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/collect.vue?macro=true";
import { default as completeOrderVWwutaD4w5Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/completeOrder.vue?macro=true";
import { default as contactSve1bPQ7AJMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/contact.vue?macro=true";
import { default as downloadfcn4GQRLYnMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/download.vue?macro=true";
import { default as helpwc8OX0KIsYMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/help.vue?macro=true";
import { default as indexlOscBMJFU5Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/index.vue?macro=true";
import { default as login0CxwTlBIfIMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/login.vue?macro=true";
import { default as marcoRewardsXYkuluLw7LMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marcoRewards.vue?macro=true";
import { default as _91spuid_931u5PHEA1uxMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/gift/[spuid].vue?macro=true";
import { default as _91cid_93KNEy2mhQW5Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/giftsMall/[cid].vue?macro=true";
import { default as indexzMvp6lYcOnMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/lottery/index.vue?macro=true";
import { default as indexfQBRhn4cugMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/poster/index.vue?macro=true";
import { default as promotionkxanVZDDp1Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/promotion.vue?macro=true";
import { default as accountDashboard4xgwcKHkOnMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/accountDashboard.vue?macro=true";
import { default as marcoRewardsiAuWiJz66iMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/marcoRewards.vue?macro=true";
import { default as yourGiftyrzz5zNm5bMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/yourGift.vue?macro=true";
import { default as newsDetailk9758qWTCZMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/newsDetail.vue?macro=true";
import { default as newsListftJ9dp57hAMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/newsList.vue?macro=true";
import { default as orderInfoLKUpmhHuLJMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/order/orderInfo.vue?macro=true";
import { default as orderPrint1cUBD8veoxrMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/orderPrint1.vue?macro=true";
import { default as orderStatus8XX06PwNtJMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/orderStatus.vue?macro=true";
import { default as _91searchstrs_93oKKxrjwtBOMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/all/[searchstrs].vue?macro=true";
import { default as _91appid_93AmnGsdr8yvMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/app/[appid].vue?macro=true";
import { default as _91_46_46_46brandid_937X63yafj3TMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/appbrand/[...brandid].vue?macro=true";
import { default as _91_46_46_46catgrp_93WYoCKrPuqtMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/cat/[...catgrp].vue?macro=true";
import { default as _91mcode_93skBSlNsPciMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/m/[mcode].vue?macro=true";
import { default as forgotpasswordu7uRdEHcryMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/forgotpassword.vue?macro=true";
import { default as verify_45link6DxnFkcENeMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/verify-link.vue?macro=true";
import { default as verifyvx90LqiFgzMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/verify.vue?macro=true";
import { default as _91_46_46_46modelid_93lUQb0O7eglMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/model/[...modelid].vue?macro=true";
import { default as _91_46_46_46mode_93a8my8NNS0eMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/s/[...mode].vue?macro=true";
import { default as profile8YfZqAqw77Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/profile.vue?macro=true";
import { default as contactg83wGcycA2Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/contact.vue?macro=true";
import { default as feedbackn6pxKW3wY9Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/feedback.vue?macro=true";
import { default as indexQapAtkeX1mMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/index.vue?macro=true";
import { default as _91id_93zGQvq2AL40Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/ticket/[id].vue?macro=true";
import { default as ticket9Xp8wSgfdgMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/ticket.vue?macro=true";
import { default as ticketsIoD2ZtxfZvMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/tickets.vue?macro=true";
import { default as shopNown2MEaMq79rMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shopNow.vue?macro=true";
import { default as shoppingCartSN6ZMyEGCRMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingCart.vue?macro=true";
import { default as shoppingCheckoutwZUi60WDk8Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingCheckout.vue?macro=true";
import { default as shoppingOrderDetaildCPlnHYav3Meta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingOrderDetail.vue?macro=true";
import { default as indexoFhVlIRvNwMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/upload-excel/index.vue?macro=true";
import { default as viewHistoryuucebj6HCxMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/viewHistory.vue?macro=true";
import { default as warrantym3AUDgPd4dMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/warranty.vue?macro=true";
import { default as where_45to_45buyO1fWmI5jzCMeta } from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/where-to-buy.vue?macro=true";
export default [
  {
    name: "Error",
    path: "/:Error?",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/[[Error]]/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/[slug].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/about.vue")
  },
  {
    name: "accountOrder",
    path: "/accountOrder",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/accountOrder.vue")
  },
  {
    name: "accountProduct",
    path: "/accountProduct",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/accountProduct.vue")
  },
  {
    name: "address",
    path: "/address",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/address.vue")
  },
  {
    name: "apparel-hat",
    path: "/hat",
    meta: apparel_45hatIvbu1eMqnmMeta || {},
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/apparel-hat.vue")
  },
  {
    name: "collect",
    path: "/collect",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/collect.vue")
  },
  {
    name: "completeOrder",
    path: "/completeOrder",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/completeOrder.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/contact.vue")
  },
  {
    name: "download",
    path: "/download",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/download.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/help.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/login.vue")
  },
  {
    name: "marcoRewards",
    path: "/marcoRewards",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marcoRewards.vue")
  },
  {
    name: "marketing-gift-spuid",
    path: "/marketing/gift/:spuid()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/gift/[spuid].vue")
  },
  {
    name: "marketing-giftsMall-cid",
    path: "/marketing/giftsMall/:cid()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/giftsMall/[cid].vue")
  },
  {
    name: "marketing-lottery",
    path: "/marketing/lottery",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/lottery/index.vue")
  },
  {
    name: "marketing-poster",
    path: "/marketing/poster",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/poster/index.vue")
  },
  {
    name: "marketing-promotion",
    path: "/marketing/promotion",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/marketing/promotion.vue")
  },
  {
    name: "member-accountDashboard",
    path: "/member/accountDashboard",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/accountDashboard.vue")
  },
  {
    name: "member-marcoRewards",
    path: "/member/marcoRewards",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/marcoRewards.vue")
  },
  {
    name: "member-yourGift",
    path: "/member/yourGift",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/member/yourGift.vue")
  },
  {
    name: "newsDetail",
    path: "/newsDetail",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/newsDetail.vue")
  },
  {
    name: "newsList",
    path: "/newsList",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/newsList.vue")
  },
  {
    name: "order-orderInfo",
    path: "/order/orderInfo",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/order/orderInfo.vue")
  },
  {
    name: "orderPrint1",
    path: "/orderPrint1",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/orderPrint1.vue")
  },
  {
    name: "orderStatus",
    path: "/orderStatus",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/orderStatus.vue")
  },
  {
    name: "prod-all-searchstrs",
    path: "/prod/all/:searchstrs()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/all/[searchstrs].vue")
  },
  {
    name: "prod-app-appid",
    path: "/prod/app/:appid()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/app/[appid].vue")
  },
  {
    name: "prod-appbrand-brandid",
    path: "/prod/appbrand/:brandid(.*)*",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/appbrand/[...brandid].vue")
  },
  {
    name: "prod-cat-catgrp",
    path: "/prod/cat/:catgrp(.*)*",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/cat/[...catgrp].vue")
  },
  {
    name: "prod-m-mcode",
    path: "/prod/m/:mcode()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/m/[mcode].vue")
  },
  {
    name: "prod-mail-forgotpassword",
    path: "/prod/mail/forgotpassword",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/forgotpassword.vue")
  },
  {
    name: "prod-mail-verify-link",
    path: "/prod/mail/verify-link",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/verify-link.vue")
  },
  {
    name: "prod-mail-verify",
    path: "/prod/mail/verify",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/mail/verify.vue")
  },
  {
    name: "prod-model-modelid",
    path: "/prod/model/:modelid(.*)*",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/model/[...modelid].vue")
  },
  {
    name: "prod-s-mode",
    path: "/prod/s/:mode(.*)*",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/prod/s/[...mode].vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/profile.vue")
  },
  {
    name: "service-contact",
    path: "/service/contact",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/contact.vue")
  },
  {
    name: "service-feedback",
    path: "/service/feedback",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/feedback.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/index.vue")
  },
  {
    name: "service-ticket",
    path: "/service/ticket",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/ticket.vue"),
    children: [
  {
    name: "service-ticket-id",
    path: ":id()",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/ticket/[id].vue")
  }
]
  },
  {
    name: "service-tickets",
    path: "/service/tickets",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/service/tickets.vue")
  },
  {
    name: "shopNow",
    path: "/shopNow",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shopNow.vue")
  },
  {
    name: "shoppingCart",
    path: "/shoppingCart",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingCart.vue")
  },
  {
    name: "shoppingCheckout",
    path: "/shoppingCheckout",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingCheckout.vue")
  },
  {
    name: "shoppingOrderDetail",
    path: "/shoppingOrderDetail",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/shoppingOrderDetail.vue")
  },
  {
    name: "upload-excel",
    path: "/upload-excel",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/upload-excel/index.vue")
  },
  {
    name: "viewHistory",
    path: "/viewHistory",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/viewHistory.vue")
  },
  {
    name: "warranty",
    path: "/warranty",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/warranty.vue")
  },
  {
    name: "where-to-buy",
    path: "/where-to-buy",
    component: () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/pages/where-to-buy.vue")
  }
]